import React from 'react';
import AddVoiceCampaign from './AddVoiceCampaign';
import CloneVoiceCampaign from './CloneVoiceCampaign';
import VoiceCampaignInfo from './VoiceCampaignInfo';
import ListVoiceCampaign from './ListVoiceCampaign';
import ListHistoricalVoiceCampaign from './ListHistoricalVoiceCampaign';
import ListScheduleVoiceCampaign from './ListScheduleVoiceCampaign';
import AddVoiceFile from './AddVoiceFile';
import ListVoiceFiles from './ListVoiceFiles';
import AddVoicePlan from './AddVoicePlan';
import ListVoicePlans from './ListVoicePlans';	
import AddVoiceBlacklist from './AddVoiceBlacklist';
import ListVoiceBlacklist from './ListVoiceBlacklist';
import UploadBlacklistFile from './UploadBlacklistFile';
import AddVoiceDnd from './AddVoiceDnd';
import UploadDndFile from './UploadDndFile';
import { Route, Switch } from "react-router-dom";
import ListSuperadminVoiceCampaign from './ListSuperadminVoiceCampaign';
import ManageCampaignSuperadmin from './ManageCampaignSuperadmin';
import AddTTSPlan from './AddTTSPlan';
import ListTTSPlans from './ListTTSPlans';
import ViewVoiceBase from './ViewVoiceBase';
import UpdateVoiceCampaign from './UpdateVoiceCampaign';
import ListHistoricalVoiceCampaignAdmin from './ListHistoricalVoiceCampaignSuperadmin';
import ListSuperadminPromptCampaign from './ListSuperadminPromptCampaign';
import CvcSummary from './CvcSummary';
import CampaignOperation from './CampaignOperation';
import AddWhitelist from './AddWhiteList';
import ListWhitelist from './ListWhiteList';

const Campaign = (props) => {
	const urlPrefix = props.app.urlPrefix;
	return (

		<div className="">
			<Switch>
				<Route path={`${urlPrefix}/add-voice-campaign`} ><AddVoiceCampaign app={props.app} /></Route>
				<Route path={`${urlPrefix}/voice-campaign-summary`} ><ListVoiceCampaign app={props.app} /></Route>
				<Route path={`${urlPrefix}/voice-superadmin-campaign-summary`} ><ListSuperadminVoiceCampaign app={props.app} /></Route>
				<Route path={`${urlPrefix}/prompt-voice-superadmin-campaign-summary`} ><ListSuperadminPromptCampaign app={props.app} /></Route>
				<Route path={`${urlPrefix}/historical-voice-campaign-summary`} ><ListHistoricalVoiceCampaign app={props.app} /></Route>
				<Route path={`${urlPrefix}/schedule-voice-campaign-summary`} ><ListScheduleVoiceCampaign app={props.app} /></Route>
				<Route path={`${urlPrefix}/add-voice-files`} ><AddVoiceFile app={props.app} /></Route>
				<Route path={`${urlPrefix}/voice-files`} ><ListVoiceFiles app={props.app} /></Route>
				<Route path={`${urlPrefix}/add-voice-plan`} ><AddVoicePlan app={props.app} /></Route>
				<Route path={`${urlPrefix}/voice-plans`} ><ListVoicePlans app={props.app} /></Route>
				<Route path={`${urlPrefix}/add-voice-blacklist`} ><AddVoiceBlacklist app={props.app} /></Route>
				<Route path={`${urlPrefix}/bulk-voice-blacklist`} ><UploadBlacklistFile app={props.app} /></Route>
				<Route path={`${urlPrefix}/add-blacklist-dnd`} ><AddVoiceDnd app={props.app} /></Route>
				<Route path={`${urlPrefix}/bulk-blacklist-dnd`} ><UploadDndFile app={props.app} /></Route>
				<Route path={`${urlPrefix}/voice-blacklist`} ><ListVoiceBlacklist app={props.app} /></Route>
				<Route path={`${urlPrefix}/voice-campaign-info/:campaignId`} render={(routeprops) => (
					<VoiceCampaignInfo campaignId={routeprops.match.params.campaignId} app={props.app} {...routeprops} />)
					} />
				<Route path={`${urlPrefix}/clone-campaign/:campaignId`} render={(routeprops) => (
					<CloneVoiceCampaign campaignId={routeprops.match.params.campaignId} app={props.app} {...routeprops} />)
					} />
				<Route path={`${urlPrefix}/update-voice-campaign/:campaignId`} render={(routeprops) => (
					<UpdateVoiceCampaign campaignId={routeprops.match.params.campaignId} app={props.app} {...routeprops} />)
					} />
				<Route path={`${urlPrefix}/manage-campaigns-superadmin`} ><ManageCampaignSuperadmin app={props.app} /></Route>
				<Route path={`${urlPrefix}/historical-campaign-summary-superadmin`} ><ListHistoricalVoiceCampaignAdmin app={props.app} /></Route>
				<Route path={`${urlPrefix}/add-tts-plan`} ><AddTTSPlan app={props.app} /></Route>
				<Route path={`${urlPrefix}/tts-plans`} ><ListTTSPlans app={props.app} /></Route>
				<Route path={`${urlPrefix}/view-voice-base`} ><ViewVoiceBase app={props.app} /></Route>
				<Route path={`${urlPrefix}/cvc-summary`} ><CvcSummary app={props.app} /></Route>
				<Route path={`${urlPrefix}/campaign-operations`} ><CampaignOperation app={props.app} /></Route>
				<Route path={`${urlPrefix}/add-whitelist`} ><AddWhitelist app={props.app} /></Route>
				<Route path={`${urlPrefix}/view-whitelist`} ><ListWhitelist app={props.app} /></Route>	
			</Switch>
		</div>

	);
}

export default Campaign;
